// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_HOMEPAGE = "Zp\u011bt na hlavn\u00ed str\u00e1nku";
export const WIKI_REVIEWS_SEARCH = "Hledej";
export const WIKI_REVIEWS_SEARCH_PLACEHOLDER = "Hledej produkt...";
export const WIKI_REVIEWS_SEARCH_RESULT_query_count = ["%(count)s produkt pro \"%(query)s\" v Centru recenz\u00ed", "%(count)s produkty pro \"%(query)s\" v Centru recenz\u00ed", "%(count)s produkt\u016f pro \"%(query)s\" v Centru recenz\u00ed"];
